import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";

const FEATURES = [
  { label: "Random short links",           free: true,  pro: true  },
  { label: "Custom links",                 free: false, pro: true  },
  { label: "Link history & dashboard",     free: false, pro: true  },
  { label: "Click analytics",              free: false, pro: true  },
  { label: "Automatic QR code generation", free: false, pro: true  },
  { label: "Rename & update destinations", free: false, pro: true  },
  { label: "Organize into folders",        free: false, pro: true  },
  { label: "Delete links",                 free: false, pro: true  },
];

function Cell({ has }) {
  return (
    <Box sx={{ width: 56, display: "flex", justifyContent: "center", flexShrink: 0 }}>
      {has ? (
        <CheckRoundedIcon sx={{ fontSize: 18, color: "primary.main" }} />
      ) : (
        <CloseRoundedIcon sx={{ fontSize: 18, color: "text.disabled" }} />
      )}
    </Box>
  );
}

export default function BenefitsTable({ onUpgrade }) {
  return (
    <Card
      sx={{
        width: { xs: "calc(100vw - 32px)", sm: 500 },
        maxWidth: 500,
        bgcolor: "background.paper",
        mt: 2,
      }}
    >
      <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
        {/* Heading */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
          <WorkspacePremiumRoundedIcon color="primary" fontSize="small" />
          <Typography variant="h6" fontWeight={800} letterSpacing={-0.5}>
            Blinkz Pro
          </Typography>
        </Box>
        <Typography color="text.secondary" fontSize="0.875rem" sx={{ mb: 3 }}>
          Upgrade for the full link shortener experience.
        </Typography>

        {/* Column headers */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
          <Box sx={{ flex: 1 }} />
          <Typography variant="caption" fontWeight={700} color="text.disabled" sx={{ width: 56, textAlign: "center" }}>
            FREE
          </Typography>
          <Typography variant="caption" fontWeight={700} color="primary.main" sx={{ width: 56, textAlign: "center" }}>
            PRO
          </Typography>
        </Box>

        {/* Feature rows */}
        {FEATURES.map((f) => (
          <Box
            key={f.label}
            sx={{
              display: "flex",
              alignItems: "center",
              py: 1.1,
              borderTop: "1px solid",
              borderColor: "divider",
            }}
          >
            <Typography variant="body2" sx={{ flex: 1, fontSize: "0.875rem" }}>
              {f.label}
            </Typography>
            <Cell has={f.free} />
            <Cell has={f.pro} />
          </Box>
        ))}

        {/* CTA */}
        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={onUpgrade}
          startIcon={<WorkspacePremiumRoundedIcon />}
          sx={{ mt: 3, borderRadius: 50, py: 1.25, fontWeight: 700 }}
        >
          Upgrade to Pro · $13.99/year
        </Button>
      </CardContent>
    </Card>
  );
}
